<template>
  <div
    v-if="data.homeclassType == 2"
    id="item"
    class="animate fadeInUp"
    @click="routerNewHomeclass()"
  >
    <div class="left">
      <div class="user">
        <div class="img" :style="gravatar(data.user.gravatar)" />
        <span>{{ data.user.name }}</span>
      </div>
      <div class="content">
        <h1 v-if="data.pax == 1">1 至 2 人拼课</h1>
        <h1 v-else>3 至 8 人拼课</h1>

        <h2>
          <span>
            {{ $moment(data.date[0]).format("M月D日 ddd") }} {{ data.openingDate.time }} -
            {{ data.openingDate.timeEnd }} 开课
          </span>
          <span id="address">{{ data.address }}</span>
        </h2>
        <h3>
          {{ data.regular + data.extra }} 次课 · {{ data.duration }} 小时 ·
          {{ Object.keys(data.timeslot).filter(item => data.timeslot[item].isSelected).length }}
          次/周 ·
          <span
            v-if="data.teacher_type == 1"
          >中教 + 外教</span>
          <span v-else>全外教课</span>
        </h3>
      </div>
    </div>
    <div class="right">
      <div class="container">
        <div class="action" @click="routerNewHomeclass(data)">¥{{ data.price }}</div>
        <span v-if="data.spots && data.pay_status == 1">{{ data.spots }} 个名额</span>
      </div>
    </div>
  </div>
  <div v-else-if="data.homeclassType == 1" id="item" class="animate fadeInUp" @click="router(data)">
    <div class="left">
      <div class="user">
        <div :style="gravatar(data.gravatar)" class="img" />
        <span>{{ data.name }}</span>
      </div>
      <div class="content">
        <h1>
          <span>{{ data.pax }} 人拼课</span>
          <span v-if="data.type == 1 || data.type == 2" class="homeclass-promo-label label">新人拼课</span>
        </h1>
        <h2>
          <span v-if="data.type != 1">
            {{ getDateText(data.all_day[0]) }} 至
            {{ getDateText(data.all_day[data.all_day.length - 1]) }}
          </span>
          <span v-if="data.type != 1">
            <span>{{ weekday[data.weekday] }} {{ data.time }}</span>
            <span v-if="data.weekday_two">，{{ weekday[data.weekday_two] }} {{ data.time_two }}</span>
          </span>
          <span v-else>{{ data.promoClassTime }}</span>
          <br />
          <span id="address">{{ data.address }}</span>
        </h2>
        <h3>
          <span>{{ data.all_day.length }} 次课</span>
          <span v-if="data.class == 0 || data.class == 2">· 全外教课</span>
          <span v-if="data.class == 1">· 中教 + 外教</span>
          <span v-if="data.length != null">· {{ length[data.length] }}</span>
          <span v-if="data.status_one">· 即将结束</span>
          <span v-if="data.status_two">· 拼课结束</span>
        </h3>
      </div>
    </div>
    <div class="right">
      <div class="container">
        <div class="action">¥{{ data.price }}</div>
        <span v-if="data.remainder">{{ data.remainder }} 个名额</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Item",
  props: ["data", "isPromoAvailability", "promo"],
  data() {
    return {
      weekday: ["每周日", "每周一", "每周二", "每周三", "每周四", "每周五", "每周六", "每周日"],
      length: ["", "季度", "半年", "全年", "一个月"],
    }
  },
  created() { },
  mounted() { },
  methods: {
    gravatar(url) {
      return `background-image:url(${url});`
    },
    getDateText(item) {
      let date = new Date(item)
      return `${date.getMonth() + 1} 月 ${date.getDate()} 日`
    },
    routerNewHomeclass() {
      this.$router.push({
        name: "Homelesson",
        params: {
          id: this.data.id,
        },
      })
    },
    router(item) {
      let users = ""
      let isSubUser = []
      if (item.sub_user_id) {
        users = JSON.parse(item.sub_user_id)
        isSubUser = users.filter(user => user.u_id == bus.user.user_id)
      }
      if (
        item.type == 0 ||
        !item.type ||
        (item.type > 0 &&
          this.isPromoAvailability &&
          item.type == this.promo.type &&
          item.area == this.promo.city) ||
        (item.type > 0 && item.name === bus.user.name) ||
        isSubUser[0]
      ) {
        this.$router.push({
          name: "homeclasspool",
          params: {
            h_id: item.h_id,
          },
        })
      } else {
        if (!this.isPromoAvailability) {
          this.$toast("抱歉，您没有新人拼课特权")
        } else {
          this.$toast(`您的新人拼课只适用于${bus.getAreaName(this.promo.city)}市`)
        }
      }
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

#item {
  display: flex;
  width: 100%;
  margin: auto;
  padding: 20px 5%;
  border-bottom: 1px solid #f2f2f2;
  justify-content: space-between;
  align-items: center;
  &:active {
    background-color: #f9f9f9;
  }
  .left {
    .user {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .img {
        width: 35px;
        height: 35px;
        border-radius: 100%;
        background-position: center;
        background-size: cover;
        margin-right: 8px;
        background-color: #eee;
      }
      span {
        font-size: 13px;
        font-weight: 500;
      }
    }
    .content {
      @include avenir();
      h1 {
        font-weight: 500;
        margin-bottom: 5px;
        font-size: 17px;
      }
      h2 {
        font-weight: 300;
        line-height: 1.5;
        font-size: 15px;
      }
      #address {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      h3 {
        font-size: 13px;
        font-weight: 400;
        opacity: 0.8;
        // display: none;
        line-height: 1.5;
        margin: 15px 0 0 0;
        .red {
          font-weight: 500;
        }
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    margin-left: 5px;
    .container {
      position: relative;
      .action {
        text-align: center;
        width: 65px;
        background: $lightBlue;
        color: $blue;
        padding: 5px;
        border-radius: 20px;
        font-size: 13px;
        @include avenir-demi();
      }
      span {
        font-size: 13px;
        font-weight: 400;
        text-align: center;
        width: 100%;
        color: $grey;
        display: block;
        position: absolute;
        transform: scale(0.85);
      }
    }
  }
}
</style>
